import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { authStorage } from '../../lib/auth-storage'
import { USER_ROLES } from '../../types/auth'

function isDoctorAwaitingApproval(role: string | null | undefined, status: string | undefined) {
  return role === USER_ROLES.DOCTOR && status !== 'approved'
}

export function ProtectedRoute() {
  const location = useLocation()
  const { session, isLoading } = useAuth()
  const token = authStorage.getToken()

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (isLoading && !session) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-parch-50 text-sm text-ink-600">
        Loading your session...
      </div>
    )
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (
    isDoctorAwaitingApproval(session.role, session.user.status) &&
    location.pathname !== '/account-status'
  ) {
    return <Navigate to="/account-status" replace />
  }

  return <Outlet />
}
